import React from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import styled from 'styled-components';

// Import particle configurations
import configDark from "../config/particlesjs-config.json";
import configLight from "../config/particlesjs-config-light.json";

const Box = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
`;

const ParticleComponent = (props) => {
  const particlesInit = async (main) => {
    await loadFull(main); // Ensures all particles features are loaded
  };

  return (
    <Box>
      {/* Using `options` instead of `params` */}
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={props.theme === "light" ? configLight : configDark}
      />
    </Box>
  );
};

export default ParticleComponent;
